'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var inlineStylePrefixer = require('inline-style-prefixer');
var calc = _interopDefault(require('inline-style-prefixer/lib/plugins/calc'));
var crossFade = _interopDefault(require('inline-style-prefixer/lib/plugins/crossFade'));
var cursor = _interopDefault(require('inline-style-prefixer/lib/plugins/cursor'));
var filter = _interopDefault(require('inline-style-prefixer/lib/plugins/filter'));
var flex = _interopDefault(require('inline-style-prefixer/lib/plugins/flex'));
var flexboxIE = _interopDefault(require('inline-style-prefixer/lib/plugins/flexboxIE'));
var flexboxOld = _interopDefault(require('inline-style-prefixer/lib/plugins/flexboxOld'));
var gradient = _interopDefault(require('inline-style-prefixer/lib/plugins/gradient'));
var imageSet = _interopDefault(require('inline-style-prefixer/lib/plugins/imageSet'));
var position = _interopDefault(require('inline-style-prefixer/lib/plugins/position'));
var sizing = _interopDefault(require('inline-style-prefixer/lib/plugins/sizing'));
var transition = _interopDefault(require('inline-style-prefixer/lib/plugins/transition'));

function decl() {
  for (var _len = arguments.length, value = Array(_len), _key = 0; _key < _len; _key++) {
    value[_key] = arguments[_key];
  }

  if (value.length === 1) {
    return value[0];
  }
  return value;
}

function multidecl() {
  for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    values[_key2] = arguments[_key2];
  }

  return {
    type: "multidecl",
    values: values
  };
}

function rule(defs) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return {
    type: "rule",
    defs: defs,
    parents: parents
  };
}

function keyframes(defs) {
  return {
    type: "keyframes",
    defs: defs
  };
}

function font() {
  for (var _len3 = arguments.length, defs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    defs[_key3] = arguments[_key3];
  }

  return {
    type: "font",
    defs: defs
  };
}

function node(ns, name, deps, def, refs) {
  return {
    ns: ns, name: name,
    deps: deps, def: def,
    refs: refs
  };
}

var types = /*#__PURE__*/Object.freeze({
  decl: decl,
  multidecl: multidecl,
  rule: rule,
  keyframes: keyframes,
  font: font,
  node: node
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function stringifyRules(rules, processSelector, pretty) {
  var NL = pretty ? "\n" : ""; // newline
  var lines = [];
  for (var i = 0; i < rules.length; i++) {
    var rule = rules[i];
    stringifyRule(pretty, processSelector, lines, rule.selector, rule.def);
  }
  return lines.join(NL);
}

function stringifyRule(pretty, processSelector, lines, selector, defs) {
  var indent = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";

  var IND = pretty ? "  " : ""; // indent
  var SP = pretty ? " " : ""; // space
  var chindent = "" + indent + IND;
  var keys = Object.keys(defs);
  if (!keys.length) {
    return;
  }
  lines.push("" + indent + processSelector(selector) + SP + "{");
  for (var i = 0; i < keys.length; i++) {
    var name = keys[i];
    var value = defs[name];
    var prop = dashify(name);
    if (Array.isArray(value)) {
      for (var _i = 0; _i < value.length; _i++) {
        var val = value[_i];
        lines.push("" + chindent + prop + ":" + SP + val + ";");
      }
    } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
      stringifyRule(pretty, processSelector, lines, name, value, chindent);
    } else {
      lines.push("" + chindent + prop + ":" + SP + value + ";");
    }
  }
  lines.push(indent + "}");
}

function dashify(str) {
  return str.replace(/([A-Z])/g, "-$1").replace(/^ms-/, "-ms-").toLowerCase();
}

/* eslint-disable */
var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

var config = {
  plugins: [calc, crossFade, cursor, filter, flex, flexboxIE, flexboxOld, gradient, imageSet, position, sizing, transition],
  prefixMap: { "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": wms, "flexBasis": w, "flexDirection": wms, "flexGrow": w, "flexFlow": wms, "flexShrink": w, "flexWrap": wms, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "touchAction": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w }
};

var prefix = inlineStylePrefixer.createPrefixer(config);

var TEMP = "temp";
var PERM = "perm";

function toposort(nodes) {
  var sorted = [];
  var marks = Object.create(null);

  var keys = Object.keys(nodes);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!marks[key]) {
      visit(sorted, nodes, marks, key);
    }
  }
  return sorted;
}

function visit(sorted, nodes, marks, key) {
  var node = nodes[key];
  if (!node) {
    if (process.env.NODE_ENV !== "production") {
      console.error(new Error("reisy: Invalid dependency on \"" + key + "\". A typo maybe?"));
    }
    return;
  }
  if (marks[key] === TEMP) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("reisy: Node \"" + key + "\" is part of a cyclic dependency.");
    }
  }
  if (marks[key]) {
    return;
  }

  marks[key] = TEMP;
  for (var i = 0; i < node.deps.length; i++) {
    var dep = node.deps[i];
    visit(sorted, nodes, marks, dep);
  }
  marks[key] = PERM;

  sorted.push(node);
}

var RRMATCH = /(__rreq__[0-9]+)/g;

var Processor = function () {
  function Processor() {
    classCallCheck(this, Processor);

    this.nodes = [];
    this.overrides = [];
    this.namespaces = {};
    this.pretty = process.env.NODE_ENV !== "production";
    this.prefix = "";
    this.rules = null;
    this.registry = null;
    this.registryRequests = [];
    this.registryRequestCount = 0;
  }

  createClass(Processor, [{
    key: "resolve",
    value: function resolve() {
      var _this = this;

      this.rules = [];
      this.registry = {};
      this.registryRequests = [];

      // 1. apply overrides
      var nodes = {};
      registerNodes(nodes, this.nodes, false);
      registerNodes(nodes, this.overrides);

      // 2. topologically sort the nodes based on their dependencies
      nodes = toposort(nodes);

      // 3. resolve the nodes, collecting them to individual rules
      for (var i = 0; i < nodes.length; i++) {
        var node$$1 = nodes[i];
        this.processNode(node$$1);
      }

      var rules = this.rules;

      // 3.5: prefix all the rules and resolve open registry requests

      var _loop = function _loop(_i) {
        var rule$$1 = rules[_i];
        rule$$1.selector = rule$$1.selector.replace(RRMATCH, function (m) {
          return interpolatedValue(_this.registry[_this.registryRequests[m]]);
        });
        Object.keys(rule$$1.def).forEach(function (k) {
          var nk = k.replace(RRMATCH, function (m) {
            return interpolatedValue(_this.registry[_this.registryRequests[m]]);
          });
          if (nk !== k) {
            rule$$1.def[nk] = rule$$1.def[k];
            delete rule$$1.def[k];
          }
        });
        rule$$1.def = prefix(rule$$1.def);
      };

      for (var _i = 0; _i < rules.length; _i++) {
        _loop(_i);
      }

      // 4. serialize the rules to css
      var css = stringifyRules(rules, this.prefixSelector.bind(this), this.pretty);

      return css;
    }
  }, {
    key: "prefixSelector",
    value: function prefixSelector(selector) {
      var _this2 = this;

      if (!this.prefix || selector.match(/^(\d|@).*/)) {
        return selector;
      }
      return selector.split(",").map(function (selector) {
        return (_this2.prefix + " " + selector.trim()).trim();
      }).join(", ");
    }
  }, {
    key: "ClassName",
    value: function ClassName(node$$1) {
      var ns = node$$1.ns,
          name = node$$1.name;

      if (!ns) {
        return name;
      }
      var className = ns + "-" + name;
      if (this.pretty) {
        return className;
      }

      // create a tiny hash of the className, just to save some bytes :-)
      var value = 5381;
      var i = className.length;

      while (i) {
        value = value * 33 ^ className.charCodeAt(--i);
      }

      return "_" + (value >>> 0).toString(36);
    }
  }, {
    key: "interpolate",
    value: function interpolate(parts) {
      var _this3 = this;

      if ((typeof parts === "undefined" ? "undefined" : _typeof(parts)) !== "object") {
        return parts;
      }
      if (parts.length === 2 && !parts[0]) {
        return interpolatedValue(this.registry[parts[1]]);
      }
      return parts.map(function (part, i) {
        return i % 2 === 0 ? String(part) : interpolatedValue(_this3.getFromRegistry(part));
      }).join("").trim();
    }
  }, {
    key: "getFromRegistry",
    value: function getFromRegistry(key) {
      var data = this.registry[key];
      if (data === undefined) {
        this.registryRequestCount++;
        var value = "__rreq__" + this.registryRequestCount;
        this.registryRequests[value] = key;
        return { value: value };
      }
      return data;
    }
  }, {
    key: "processNode",
    value: function processNode(node$$1) {
      var _this4 = this;

      var key = node$$1.key,
          ns = node$$1.ns,
          name = node$$1.name,
          def = node$$1.def;
      var type = def.type;
      var registry = this.registry,
          namespaces = this.namespaces;

      var value = void 0;

      if (type === "rule") {
        var className = this.ClassName(node$$1);
        value = {
          type: "rule",
          selector: "" + (node$$1.ns ? "." : "") + className,
          className: className
        };
        var seen = {};

        var defs = def.defs;

        for (var i = 0; i < defs.length; i++) {
          var _def2 = defs[i];
          this.processParents(seen, value, _def2.parents, key);
          var _rule2 = createRule(value.selector);
          this.processRule(_rule2, _def2.defs);
        }
      } else if (type === "font") {
        value = this.ClassName(node$$1);
        var family = ["fontFamily", decl(value)];
        // attach the font name using a temporary property here…
        def.defs.forEach(function (def) {
          def.unshift(family);
          _this4.processRule(createRule("@font-face"), def);
          def.shift();
        });
        value = Value(value);
      } else if (type === "keyframes") {
        value = this.ClassName(node$$1);
        this.processNestedRule("@keyframes " + value, def.defs);
        // and then there is old webkits :-(
        this.processNestedRule("@-webkit-keyframes " + value, def.defs);
        value = Value(value);
      } else {
        value = Value(this.interpolate(def.value));
      }
      registry[key] = value;
      if (ns) {
        if (!namespaces[ns]) {
          namespaces[ns] = {};
        }
        namespaces[ns][name] = value.type === "rule" ? value.className : value.value;
      }
      return value;
    }
  }, {
    key: "processParents",
    value: function processParents(seen, value, parents, nodekey) {
      for (var i = 0; i < parents.length; i++) {
        var key = parents[i];
        if (seen[key]) {
          continue;
        }
        seen[key] = true;
        var parent = this.registry[key];
        if (parent) {
          value.className = parent.className + " " + value.className;
        } else {
          console.error(new Error("reisy: \"" + nodekey + "\" extends non-existant \"" + key + "\". A typo maybe?"));
        }
        seen[key] = true;
      }
    }
  }, {
    key: "processNestedRule",
    value: function processNestedRule(name, defs, _rule) {
      var rule$$1 = createRule(name);
      var container = _rule || createRule("");
      var rules = this.rules;
      this.rules = [];
      this.processRule(container, defs);
      for (var i = _rule ? 0 : 1; i < this.rules.length; i++) {
        var r = this.rules[i];
        rule$$1.def[r.selector] = r.def;
      }
      this.rules = rules;
      this.rules.push(rule$$1);
      return rule$$1;
    }
  }, {
    key: "processRule",
    value: function processRule(rule$$1, defs) {
      var _this5 = this;

      this.rules.push(rule$$1);

      var _loop2 = function _loop2(i) {
        var _def = defs[i];
        var name = _this5.interpolate(_def[0]);
        var def = _def[1];
        var type = def.type;

        if (type === "rule") {
          var _defs2 = def.defs;

          if (name.startsWith("@")) {
            _this5.processNestedRule(name, _defs2, createRule(rule$$1.selector));
            return "continue";
          }
          var selector = rule$$1.selector.split(",").reduce(function (arr, _selector) {
            var selector = _selector.trim();
            return arr.concat(name.split(",").map(function (_name) {
              var name = _name.includes("&") ? _name.trim() : "& " + _name.trim();
              return name.replace("&", selector).trim();
            }));
          }, []).join(", ");
          _this5.processRule(createRule(selector), _defs2);
        } else {
          var value = type === "multidecl" ? def.values.map(function (value) {
            return _this5.interpolate(value);
          }) : _this5.interpolate(def);
          rule$$1.def[camelify(name)] = value;
        }
      };

      for (var i = 0; i < defs.length; i++) {
        var _ret2 = _loop2(i);

        if (_ret2 === "continue") continue;
      }
    }
  }]);
  return Processor;
}();

var ANONYMOUS = 0;
function registerNodes(map, nodes) {
  var merge = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  for (var i = 0; i < nodes.length; i++) {
    var node$$1 = nodes[i];
    var ns = node$$1.ns,
        _name2 = node$$1.name,
        deps = node$$1.deps,
        _def3 = node$$1.def;

    var key = ns ? ns + "." + _name2 : "__" + ANONYMOUS++;

    if (map[key] && merge) {
      var _node$deps;

      var _node = map[key];
      var newdef = processTypeDef(_def3, _node.def, key);
      if (typeof newdef !== "undefined") {
        _node.def = newdef;
      }
      (_node$deps = _node.deps).push.apply(_node$deps, toConsumableArray(deps));
    } else {
      map[key] = {
        key: key,
        ns: ns, name: _name2,
        deps: deps.slice(),
        def: processTypeDef(_def3)
      };
    }
  }
  return map;
}

function processTypeDef(_def, olddef, key) {
  var def = (typeof _def === "undefined" ? "undefined" : _typeof(_def)) !== "object" || Array.isArray(_def) ? { type: "decl", value: _def } : _def;
  var type = def.type;

  if (olddef && type !== olddef.type) {
    console.error(new Error("reisy: Incompatible types for node \"" + key + "\": got \"" + type + "\" expected \"" + olddef.type + "\"."));
    return;
  }
  if (type !== "rule") {
    return def;
  }
  var parents = def.parents,
      defs = def.defs;

  var _defs = { parents: parents, defs: defs };
  if (olddef) {
    olddef.defs.push(_defs);
    return olddef;
  }
  return {
    type: type,
    defs: [_defs]
  };
}

function createRule(selector) {
  return {
    selector: selector,
    def: {}
  };
}

function Value(value) {
  return {
    type: "value",
    value: value
  };
}

function interpolatedValue(arg) {
  if (typeof arg === "undefined") {
    return "";
  }
  return arg.type === "rule" ? arg.selector : arg.value;
}

function camelify(str) {
  return str.replace(/^-ms-/, "ms-").replace(/-(\w|$)/, function (_, ch) {
    return ch.toUpperCase();
  });
}

var Reisy = function () {
  function Reisy() {
    classCallCheck(this, Reisy);

    this.reset();
  }

  createClass(Reisy, [{
    key: "reset",
    value: function reset() {
      this._processor = new Processor();
      this._listeners = new Set();
      return this;
    }
  }, {
    key: "pretty",
    value: function pretty(_pretty) {
      this._processor.pretty = _pretty;
    }
  }, {
    key: "prefix",
    value: function prefix(_prefix) {
      this._processor.prefix = _prefix;
    }
  }, {
    key: "notify",
    value: function notify() {
      var _this = this;

      this._listeners.forEach(function (listener) {
        return listener(_this);
      });
    }
  }, {
    key: "on",
    value: function on(listener) {
      this._listeners.add(listener);
      return this;
    }
  }, {
    key: "off",
    value: function off(listener) {
      this._listeners.delete(listener);
      return this;
    }
  }, {
    key: "node",
    value: function node$$1() {
      this._processor.nodes.push(node.apply(undefined, arguments));
      this.notify();
      return this;
    }
  }, {
    key: "nodes",
    value: function nodes(_nodes) {
      this._processor.nodes = this._processor.nodes.concat(_nodes);
      this.notify();
      return this;
    }
  }, {
    key: "namespace",
    value: function namespace(name) {
      if (!name) {
        return null;
      }
      var ns = this._processor.namespaces[name] || Object.create(null);
      this._processor.namespaces[name] = ns;
      return ns;
    }
  }, {
    key: "overrides",
    value: function overrides(_overrides) {
      this._processor.overrides = _overrides;
      this.notify();
      return this;
    }
  }, {
    key: "resolve",
    value: function resolve() {
      return this._processor.resolve();
    }
  }]);
  return Reisy;
}();

function use$$1() {
  var style = {};
  var classNames = [];

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.forEach(processDef);

  return {
    className: classNames.join(" "),
    style: prefix(style)
  };

  function processDef(def) {
    if (!def) {
      return;
    }
    if (typeof def === "string") {
      classNames.push(def);
    } else if (Array.isArray(def)) {
      def.forEach(processDef);
    } else {
      Object.assign(style, def);
    }
  }
}

function inject$$1() {
  var instance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reisy;

  var style = document.createElement("style");
  document.head.appendChild(style);
  setCSS();
  instance.on(setCSS);
  return function () {
    instance.off(setCSS);
    document.head.removeChild(style);
  };

  function setCSS() {
    var css = instance.resolve();
    style.textContent = css;
  }
}

// export a singleton
var reisy = new Reisy();

// XXX: remove in 2.0.0
// even though this has never been documented, we should keep exports because
// of semver
var decl$1 = decl,
    multidecl$1 = multidecl,
    rule$1 = rule,
    keyframes$1 = keyframes,
    font$1 = font,
    node$1 = node;

exports.reisy = reisy;
exports.default = Reisy;
exports.types = types;
exports.use = use$$1;
exports.inject = inject$$1;
exports.decl = decl$1;
exports.multidecl = multidecl$1;
exports.rule = rule$1;
exports.keyframes = keyframes$1;
exports.font = font$1;
exports.node = node$1;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reisy/index.js
// module id = 2
// module chunks = 1